var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"title":_vm.title},on:{"logout":function($event){return _vm.$emit('logout')}}},[_c('div',{staticClass:"mt-5",domProps:{"innerHTML":_vm._s(_vm.$mystore.state.agenda)}})])}
var staticRenderFns = []

export { render, staticRenderFns }